<template>
<!-- 预约设计 -->
<div class="viewContainer">
  <div v-show="ishow == 1">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <el-collapse-transition>
      <div v-show="show3">
      <el-form :inline="true" :model="formInline" class="findform">
        <!-- <el-form-item style="display:flex;width:100%" label="客户姓名：">
          <el-input v-model="name" placeholder="请输入客户姓名" maxlength="20"></el-input>
        </el-form-item> -->
        <el-form-item label="客户电话：" style="display:flex;width:30%">
          <el-input v-model="phone" placeholder="请输入客户电话" maxlength="11"
          onkeyup="value=value.replace(/[^\d\.]/g,'').replace('.','')" style="width:90%"/>
        </el-form-item>
        <el-form-item label="客户状态：" style="display:flex;width:30%">
          <el-select v-model="statusId" placeholder="请选择" style="width:90%">
            <el-option v-for="(item,index) in cStatusarr" :key="index" :value="item.Id" :label="item.Name"/>
          </el-select>
        </el-form-item>
        <el-form-item label="设计师：" style="display:flex;width:30%">
          <el-cascader v-model="shejishi" :clearable="true" placeholder="请选择设计师"
            :options="options" filterable @change="handleChange" style="width:90%"/>
          <!-- <el-select v-model="companyId" filterable placeholder="请选择装修公司">
            <el-option v-for="item in options1" :key="item.Id" :label="item.Name" :value="item.Id"/>
          </el-select>-->
        </el-form-item>
        <el-form-item> <el-button type="danger" @click="findinfo()">查 询</el-button> </el-form-item>
      </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">预约设计</p>
        <span style="margin-left:30px">今日预约：{{msgarr[0]}}</span>
        <span style="margin-right:10px">本周预约：{{msgarr[1]}}</span>
        <span style="margin-right:10px">本月预约：{{msgarr[2]}}</span>
        <span style="margin-right:10px">全部预约：{{msgarr[3]}}</span>
      </section>
      <div class="table_container">
      <el-table :data="goodList" stripe border>
        <el-table-column label="序号" align="center" width="60px">
          <template scope="scope"> {{scope.$index + 1}} </template>
        </el-table-column>
        <!-- <el-table-column label="客户姓名" align="center">
          <template scope="scope">{{scope.row.Contact}}</template>
        </el-table-column> -->
        <el-table-column label="客户电话" align="center">
          <template scope="scope">{{scope.row.Phone}}</template>
        </el-table-column>
        <el-table-column label="预约时间" align="center">
          <template scope="scope">{{scope.row.CTime}}</template>
        </el-table-column>
        <el-table-column label="客户地址" align="center">
          <template scope="scope">
            <span :title=" scope.row.ProvinceName+'-'+scope.row.CityName">{{scope.row.ProvinceName}}-{{scope.row.CityName}}</span>
          </template>
        </el-table-column>
        <el-table-column label="小区名称" align="center">
          <template scope="scope">{{scope.row.DecTypeName}}</template>
        </el-table-column>
        <el-table-column label="面积（平米）" align="center">
          <template scope="scope">{{scope.row.HousingArea}}</template>
        </el-table-column>
        <el-table-column label="户型" align="center">
          <template scope="scope">{{scope.row.HouseTypeName}}</template>
        </el-table-column>
        <el-table-column label="风格" align="center">
          <template scope="scope">{{scope.row.StyleName}}</template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template scope="scope">{{scope.row.StatusName}}</template>
        </el-table-column>
        <el-table-column label="户型图" align="center" width="150">
          <template scope="scope">
            <div style="height:36px;" class="banner_list" v-show="scope.row.ImgUrls.length > 0">
              <span @click="seebigimg(scope.row.ImgUrls)" style="color:#0099FF">预览</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="需求描述" align="center">
          <template scope="scope">{{scope.row.Remark}}</template>
        </el-table-column>
        <el-table-column label="设计师" align="center">
          <template scope="scope">{{scope.row.UserName}}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="220">
          <template scope="scope">
            <span class="handle" @click="showdoalo(scope)" v-show="scope.row.StatusId != 5">
              <i class="el-icon-s-order"></i> 跟进记录
            </span>
            <span class="handle" @click="overwork(scope)" v-show="scope.row.StatusId == 2">
              <i class="el-icon-circle-check"></i> 完工
            </span>
            <span class="handle" @click="distribution(scope)"
              v-show="(usertype==5||usertype==4||BbId==1)&&(scope.row.StatusId == 5||scope.row.StatusId == 1)">
              <i class="el-icon-sort" style="transform:rotate(90deg);"></i> 分配设计师
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="float:right;margin:10px 0;"/>
      </div>
    </div>
  </div>
  <!-- 客户已成交 -->
  <el-dialog title="确认" :center="true" :close-on-click-modal="false" :visible.sync="dialogVisible1" width="30%">
    <span style="text-align:center;display:inline-block;width:100%;margin-top:50px;margin-bottom:50px;">
      <span style="text-align:center">是否确定客户已成交？</span>
    </span>
    <span slot="footer" class="dialog-footer">
      <div style="text-align:center">
        <el-button type="danger" @click="makesure()">确 定</el-button>
        <el-button @click="dialogVisible1 = false">返 回</el-button>
      </div>
    </span>
  </el-dialog>
  <!-- 跟进记录 -->
  <el-dialog title="提示" :visible.sync="dialogVisibledelete" :before-close="handleClosezhun" center style="marrgin-top:7vh">
    <span>
      <template>
        <el-table :data="followList" stripe border style>
          <el-table-column prop="FollowerName1" label="跟进人" width="200px" align="center"></el-table-column>
          <el-table-column prop="CTime" label="跟进时间" width="200px" align="center"></el-table-column>
          <el-table-column prop="Remark" align="center" width label="跟进内容"></el-table-column>
        </el-table>
      </template>
      <div style="overflow:hidden">
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange1"  
        :current-page="pageIndex1" :page-size="5" :total="total1" style="float:right;margin-top:10px"/>
      </div>
      <div style="height:1px;background:#eee;margin-top:10px"></div>
      <div style="margin-top:10px" class="region1">添加跟进记录</div>
      <el-input type="textarea" v-model="remark" maxlength="200" placeholder="请输入跟进记录（200字以内）"
        :autosize="{ minRows: 2, maxRows: 6}" show-word-limit style="margin-top:10px;"/>
    </span>
    <span slot="footer" style="text-align:center" class="dialog-footer">
      <div style="text-align:center">
        <el-button type="danger" @click="followUp()">保 存</el-button>
      </div>
    </span>
  </el-dialog>
  <!-- 完工 -->
  <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%" center>
    <div style="text-align:center;margin-top:50px">是否确定完工？</div>
    <div slot="footer" style="margin-top:50px" class="dialog-footer">
      <el-button @click="centerDialogVisible = false">取 消</el-button>
      <el-button type="danger" @click="makeover()">确 定</el-button>
    </div>
  </el-dialog>
  <!-- 分配设计师 -->
  <el-dialog title="分配设计师" :visible.sync="dialogVisibledis" width="45%" center>
    <el-form label-width="130px" style="display:flex">
      <el-form-item label="请输入设计师名称：" style="width:50%;margin-right:10px">
        <el-input v-model="name1" placeholder="单行输入"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="danger" @click="finddes()">查 询</el-button>
      </el-form-item>
    </el-form>
    <div style="max-height:245px;overflow: auto;margin-top:-10px" class="disoutline">
      <p @click="getdesId(item.Id)" style="cursor: pointer;" class="disinline" v-for="(item,index) in desarr" :key="index">
        <img
          @click="getdesId(item.Id)"
          style="width:50px;height:50px;cursor: pointer;"
          :src="item.FaceUrl"
        />
        <span @click="getdesId(item.Id)" style="margin-left:10px;cursor: pointer;">{{item.Name}}</span>
        <el-radio
          @change="getdesId(item.Id)"
          style="position: absolute;right:0px;top:15px"
          v-model="radio"
          :label="item.Id"
        >选择</el-radio>
      </p>
      <p style="text-align:center" v-show="nofind">查无结果</p>
    </div>
    <div slot="footer" style class="dialog-footer">
      <el-button @click="dialogVisibledis = false">取 消</el-button>
      <el-button type="danger" @click="makedes()">确 定</el-button>
    </div>
  </el-dialog>
  <el-dialog title='图片查看' :visible.sync="isShowImageDialog" width="35%" center>
    <el-carousel :autoplay = "false">
      <el-carousel-item v-for="(item,index) in ShowImageDialogImgarr" :key="index"
        style="display: flex;align-items: center;justify-content: center;">
        <img style="width:300px;height:auto" :src="item" />
      </el-carousel-item>
    </el-carousel>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { getkind, SelectCustomerForLowestPricList, SelectCustomerForLowestPricDetailById, UpdateBBPayForCustomerInformation,
  SelectBBShopFollowUpList, InsertBBShopFollowUp, SelectDesignerReservationList, DistributionDesigner,SelectDCAndDesignerList,
  EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType, } from "../../api/api";
export default {
  name: "descustomer",
  mixins: [alertTrends],
  data() {
    return {
      name1: "",
      usertype: "",
      BbId: "",
      msgarr: [],
      companyId: "",
      options1: [],
      radio: "",
      tbdprovince: [],
      provinceId: 0,
      cityId: 0,
      tbdcity: [
        {
          Id: 0,
          Name: "全部"
        }
      ],
      optionsindex: 0,
      options: [
        {
          value: 0,
          label: "全部"
        }
      ],
      show3: true,
      centerDialogVisible: false,
      followList: [],
      followId: "",
      dialogVisibledis: false,
      dialogVisibledelete: false,
      dialogVisible1: false,
      pinleiptions: [],
      brandoptions: [],
      pageIndex1: 1,
      total1: 5,
      total: 10,
      remark: "",
      name: "",
      phone: "",
      nofind:false,
      Follower: [],
      statusId: 0,
      shejishi: "", // 设计师
      goodListInfo: [],
      goodList: [{}],
      shopinfo: "",
      shopinfoId: "",
      goodsName: "",
      pageIndex: 1,
      pageSize: 10,
      brandTypeId: 0,
      brandId: 0,
      cStatus: 0,
      cPhone: "",
      cName: "",
      dialogVisible: false,
      ui: "",
      ishow: 1,
      formInline: {},
      pinpaiptions: [],
      cStatusarr: [
        {
          Id: 0,
          Name: "全部"
        },
        {
          Id: 1,
          Name: "待跟进"
        },
        {
          Id: 2,
          Name: "已跟进"
        },
        {
          Id: 3,
          Name: "已完工"
        },
        {
          Id: 4,
          Name: "已评价"
        },
        {
          Id: 5,
          Name: "未分配设计师"
        }
      ],
      dcId: 0,
      DcId1: 0,
      designerId: 0,
      desarr: [],
      biaozhu: 0,
      isShowImageDialog:false,
      ShowImageDialogImgarr:[],
      // baseOssUrl: localStorage.BaseOssUrl,
    };
  },
  methods: {
    seebigimg(arr){
      this.isShowImageDialog = true;
      this.ShowImageDialogImgarr = arr;
    },
    finddes() {
      var obj = {
        name: this.name1,
        userId: localStorage.Id,
        dcId: this.DcId1
      };
      SelectDCAndDesignerList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.desarr = data.ResultObj;
          this.nofind = false
        } else {
          this.desarr = [];
          this.nofind = true
        }
      });
    },
    makedes() {
      if (this.radio == "") {
        this.showAlert('请选择设计师');
        return false;
      }
      var obj = {
        rId: this.biaozhu,
        dcId: this.DcId1,
        designerId: this.radio,
        operatorId: localStorage.Id
      };
      DistributionDesigner(obj).then(data => {
        if (data.ResultCode == 1) {
          this.dialogVisibledis = false;
          this.showAlert('分配成功', 'success');
          this.getlist();
        }
      });
    },
    getdesId(val) {
      this.radio = val;
    },
    getdes() {
      var obj = {
        name: "",
        userId: localStorage.Id,
        dcId: this.dcId
      };
      SelectDCAndDesignerList(obj).then(data => {
        if (data.ResultCode == 1) {
          var obj1 = {};
          var onj2 = {
            value: 0,
            label: "全部"
          };
          var arr = [];

      //     for (var i = 0; i < data.ResultObj.length; i++) {
      //       if (data.ResultObj[i].DesignerList + "" != "null") {
      //         for(var k = 0;k<data.ResultObj[i].DesignerList.length;k++){
      //  data.ResultObj[i].DesignerList[k].map(item => {
      //           obj1 = item;
      //           obj1["value"] = item["id"];
      //           obj1["label"] = item["name"];
      //           delete obj1["id"];
      //           delete obj1["name"];
      //           arr.push(obj1);
      //           data.ResultObj[i].DesignerList = arr;
      //         });
      //         }
      //       }
      //     }

          var obj = {};
          var obj1 = {
            value: 0,
            label: "全部"
          };
          data.ResultObj.map(item => {
            obj = item;
            obj["value"] = item["Id"];
            obj["label"] = item["Name"];
            obj["children"] = item["DesignerList"];
            delete obj["keyName"];
            delete obj["keyName"];
            this.options.push(obj);
          });
          this.options = data.ResultObj;
          this.options.unshift(obj1);
          for(var k = 0;k<this.options.length;k++){
            if(this.options[k].DesignerList!=null){
              this.options[k].DesignerList.map(item=>{
               obj1 = item;
              obj1["value"] = item["id"];
              obj1["label"] = item["name"];
              arr.push(obj1)
              this.options[k].DesignerList = arr
            })
            }
          }
        }
      });
    },
    distribution(scope) {
      this.name1 = "";
      this.radio = "";
      this.dialogVisibledis = true;
      this.DcId1 = scope.row.DcId;
      this.biaozhu = scope.row.Id;
      var obj = {
        name: this.name1,
        userId: localStorage.Id,
        dcId: scope.row.DcId
      };
      SelectDCAndDesignerList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.desarr = data.ResultObj;
          this.nofind = false
          this.getlist();
        } else {
          this.desarr = [];
          this.nofind = true
        }
      });
    },
    handleChange(val) {
      this.companyId = val[0];
      if (val.length == 1) {
        this.designerId = 0;
      } else {
        this.companyId = val[0];
        this.designerId = val[1];
      }
    },
    handleClosezhun() {
      this.dialogVisibledelete = false;
      this.getlist();
    },
    // 重置
    fnReset() {
      this.name = "";
      this.phone = "";
      this.statusId = 0;
      this.shejishi = "";
      this.companyId = 0;
      this.designerId = 0;
      // this.pageIndex = 1;
      // this.getlist();
    },
    // 查询
    findinfo() {
      this.pageIndex = 1;
      this.getlist();
    },
    makeover() {
      var obj = {
        userId: localStorage.Id,
        id: this.followId,
        operType: 4
      };
      EditDesignerIsOnlineOrIsCertificatedOrCompleteByOperType(obj).then(
        data => {
          if (data.ResultCode == 1) {
            this.centerDialogVisible = false;
            this.getlist();
            this.showAlert('操作成功', 'success');
          }
        }
      );
    },
    overwork(scope) {
      this.followId = scope.row.Id;
      // this.centerDialogVisible = true;
      this.$swal({
        type: "warning",
        text: "是否确定完工？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定"
      }).then(res => {
        if (res.value) {
          this.makeover();
        }
      });
    },
    followUp() {
      if (this.remark == "") {
        this.showAlert('请添加跟进记录');
        return false;
      }
      var obj = {
        operType: 4,
        id: this.followId,
        remark: this.remark,
        userId: localStorage.Id
      };
      InsertBBShopFollowUp(obj).then(data => {
        if (data.ResultCode == 1) {
          // this.dialogVisibledelete = false
          this.remark = "";
          this.showAlert('保存成功', 'success');
          var obj = {
            operType: 3,
            id: this.followId,
            pageIndex: this.pageIndex1,
            pageSize: 5
          };
          SelectBBShopFollowUpList(obj).then(data => {
            if (data.ResultCode == 1) {
              this.followList = data.ResultObj;
              this.total1 = data.RowsCount;
            } else if (data.ResultCode == 4) {
              this.followList = data.ResultObj;
              this.total1 = data.RowsCount;
            }
          });
        }
      });
    },
    showdoalo(scope) {
      this.pageIndex1 = 1;
      this.followId = scope.row.Id;
      this.remark = "";

      this.dialogVisibledelete = true;
      var obj = {
        operType: 3,
        id: scope.row.Id,
        pageIndex: this.pageIndex1,
        pageSize: 5
      };
      SelectBBShopFollowUpList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        } else if (data.ResultCode == 4) {
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        }
      });
      // this.getfollowlist()
    },
    getlist() {
      var obj = {
        dcId: this.companyId,
        designerId: this.designerId,
        userId: localStorage.Id,
        name: this.name,
        phone: this.phone,
        statusId: this.statusId,
        pageIndex: this.pageIndex,
        pageSize: 10
      };
      SelectDesignerReservationList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount;
          this.msgarr = data.ResultMsg.split(",");
        } else {
          this.goodList = [];
          this.msgarr = data.ResultMsg.split(",");
        }
      });
    },
    makesure() {
      var obj = {
        operType: 3,
        id: this.shopinfo.Id,
        remark: this.remark,
        userId: localStorage.Id
      };
      InsertBBShopFollowUp(obj).then(data => {
        this.dialogVisible1 = false;
        this.remark = "";
        if (data.ResultCode == 1) {
          this.getinfo();
          this.ishow = 1;
          this.getInformation();
          this.showAlert(data.ResultMsg, 'success');
        }
      });
    },
    findshop() {
      this.getinfo();
    },
    handleCurrentChange1(val) {
      this.pageIndex1 = val;
      var obj = {
        operType: 3,
        id: this.followId,
        pageIndex: this.pageIndex1,
        pageSize: 5
      };
      SelectBBShopFollowUpList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        } else if (data.ResultCode == 4) {
          this.followList = data.ResultObj;
          this.total1 = data.RowsCount;
        }
      });
    },
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getlist();
    },
    handleClose() {
      this.dialogVisibledelete = false;
    },
    //新增探低价跟进记录
    ShopFollowUp() {
      var obj = {
        operType: 1,
        id: this.shopinfo.Id,
        remark: this.remark,
        userId: localStorage.Id
      };
      InsertBBShopFollowUp(obj).then(data => {
        this.remark = "";
        if (data.ResultCode == 1) {
          this.dialogVisible = false;
          this.getInformation();
          this.showAlert('添加记录成功', 'success');
        }
      });
    },
    over() {
      this.dialogVisible1 = true;
    },
    //查询跟进列表
    getInformation() {
      var obj = {
        operType: 1,
        id: this.shopinfo.Id,
        pageIndex: this.pageIndex1,
        pageSize: 5
      };
      SelectBBShopFollowUpList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.Follower = data.ResultObj;
          this.total1 = data.RowsCount;
        } else {
          this.Follower = [];
          this.total1 = data.RowsCount;
        }
      });
    },
    //获取客户
    Obtain() {
      var obj = {
        payType: 0,
        userId: localStorage.Id,
        clpId: this.shopinfo.Id
      };
      UpdateBBPayForCustomerInformation(obj).then(data => {
        if (data.ResultCode == 1) {
          this.getinfoById();
          this.StatusId = 0;
          this.shopinfo.CPhone = data.ResultObj.CPhone;
          this.showAlert('获取客户成功', 'success');
        }
      });
    },
    getinfo() {
      var obj = {
        userId: localStorage.Id,
        cName: this.cName,
        cPhone: this.cPhone,
        cStatus: this.cStatus,
        brandTypeId: this.brandTypeId,
        brandId: this.brandId,
        goodsName: this.goodsName,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      SelectCustomerForLowestPricList(obj).then(data => {
        if (data.ResultCode == 1) {
          this.goodList = data.ResultObj;
          this.total = data.RowsCount;
        } else {
          this.goodList = [];
        }
      });
    },
    //获取详情信息
    getinfoById() {
      var obj = {
        clpId: this.shopinfoId,
        userId: localStorage.Id
      };
      SelectCustomerForLowestPricDetailById(obj).then(data => {
        if (data.ResultCode == 1) {
          this.shopinfo = data.ResultObj;
          this.getInformation();
        }
      });
    },
    genjjin() {
      this.dialogVisible = true;
    },
    goback() {
      this.ishow = 1;
      this.getinfo();
    },
    offer(scope) {},
    //获取品类
    getpinlei() {
      let that = this;

      var loginParams = {
        tableName: "tbdgoodsbrandtype",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.pinleiptions = data;
      }).catch(err => {
        this.logining = false;
      });
    },
    //获取品牌
    getbrand() {
      let that = this;

      var loginParams = {
        tableName: "tbdbrand",
        keyWord: "",
        parentId: ""
      };
      getkind(loginParams).then(data => {
        data = data.ResultObj;
        var obj = {
          Id: 0,
          Name: "全部"
        };
        data.unshift(obj);
        that.brandoptions = data;
      })
      .catch(err => {
        this.logining = false;
      });
    }
  },
  mounted() {
    this.getlist();
    this.getdes();
    this.usertype = localStorage.UserType;
    this.BbId = localStorage.BbId;
  }
};
</script>
<style scoped>
.disoutline {
  height: auto;
  border: 1px solid #eee;
  padding: 10px;
}
.disinline {
  position: relative;

  height: auto;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
.region {
  font-size: 18px;
  font-weight: 600;
  border-bottom: 1px solid #eeeeee;
  padding-bottom: 20px;
}
.region1 {
  font-size: 18px;
  font-weight: 600;
}
.ahref {
  color: #040404;
}
.ahref:hover {
  color: #F56C6C;
}
</style>


// WEBPACK FOOTER //
// desCustomer.vue?f9f3fbfe